module.exports = __webpack_public_path__ + "static/img/4.c5fd38c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/4.png
// module id = FDA0
// module chunks = 0